<template>
    <div class="alert" v-prevent-overscroll>
        <div class="alert-area">
            <div class="virtual-wrapper" :style="wrapperStyle">
                <div class="code-item" v-for="(item, index) in codeList" :key="index" :style="codeListStyle[index]"  @click="handleCopy(item)">
                    {{item}}
                </div>
                
            </div>
           
            <div class="close-area">
                <div class="close-border"></div>
                <img class="close-icon" :src="closeIconUrl" @click.stop="closeViewVirtual" />
            </div>
        </div>
    </div>
  
</template>

<script>

let closeIcon = require('@/assets/imgs/close.png')

export default {
    
    name: 'viewVirtual',

    props: {

        info: {
            type: Object,
        },
        
    },

    data() {
        return {

            closeIconUrl: closeIcon,

            wrapperStyle: {}, // 包裹框样式

            codeListStyle: [], // 券码列表样式

            codeList: [], // 券码列表
            
        }
    },

    mounted() {

        this.init()

    },

    methods: {

        init() {
            this.initCodeList(this.info)
            this.initStyle(this.info)
        },

        initCodeList(val) {
            this.codeList = val && val.prizeCode && val.prizeCode.split('#') || []
        },

        initStyle(val) {

            let { baseConfig, codeConfig } = val

            let transformWrapper = (config, imgKey) => {

                let options = {}

                if (config.position1 && config.position1.type) {
                    options[`${config.position1.type}`] =  `${config.position1.value || 0}px`
                }

                if (config.position2 && config.position2.type) {
                    options[`${config.position2.type}`] =  `${config.position2.value || 0}px`
                }

                if (config.width) {
                    options.width = `${config.width}px`
                }

                if (config.height) {
                    options.height = `${config.height}px`
                }

                if (imgKey) {
                    if (config[imgKey] && config[imgKey].url) {
                        let background = {
                            backgroundImage: `url(${config[imgKey].url})`,
                            backgroundSize: `100% 100%`,
                            backgroundPosition: '0px 0px',
                        }
                        options= Object.assign(options, background)
                    }
                }

                return options
            }

            this.wrapperStyle = baseConfig && transformWrapper(baseConfig, 'img') || {}

            let transformCode = (config) => {
                let options = {
                }
                if (config.position1 && config.position1.type) {
                    options[`${config.position1.type}`] =  `${config.position1.value || 0}px`
                }

                if (config.position2 && config.position2.type) {
                    options[`${config.position2.type}`] =  `${config.position2.value || 0}px`
                }

                options.color       = config.tipsConfig.color
                options.fontSize    = `${config.tipsConfig.fontSize}px`
                options.textStroke  = config.tipsConfig.stroke ? `1px ${config.tipsConfig.stroke}` : ''
                options.fontWeight  = config.tipsConfig.fontStyle && config.tipsConfig.fontStyle.indexOf('bold') !== -1 ? 'bold' : ''
			    options.fontStyle   = config.tipsConfig.fontStyle && config.tipsConfig.fontStyle.indexOf('italic') !== -1 ? 'italic' : ''
                return options
            }
           
            this.codeListStyle = codeConfig.map(item => item && transformCode(item) || {})

        },

        handleCopy(e) { 
           this.$copyText(e).then(
                res => {
                    this.toast('复制成功')
                },
                err => {
                    this.toast('复制出错')
                }
            );
        },

        toast(txt) { // 错误提示
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: 3000
            })
        },

        closeViewVirtual() { // 关闭查看虚拟奖品
            this.$emit('emitEvent', {
                type: 'closeViewVirtual',
                data: null,
                options: null
            })

        },

    },

}

</script>

<style lang="scss" scoped>

.alert {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.virtual-wrapper {
    position: relative;
}

.code-item {
    position: absolute;
}

.close-area {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.close-border {
    border-left: 4px dashed #fff;
    height: 100px;
}

.close-icon {
    width: 68px;
    height: 68px;
}

</style>